import { render } from "./DownloadIcon.vue?vue&type=template&id=1c3e2f96"
const script = {}
script.render = render

export default script